import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

export const getAdjustmentsSchema = createSelector(
  getProgramsCategory,
  ({ adjustmentsSchema }) => adjustmentsSchema,
);
